import React, {useEffect, useState} from "react";
import {__} from "@wordpress/i18n";
import {useChatContext} from "../ChatContext";
import {getContact, getContent} from "../api/requests";
import {LoadingMessage} from "./LoadingMessage";

export function ContactSuggestion({text, id}: ({ text: string, id: number })): React.ReactElement|null {
    const [contact, setContact] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function loadContact() {
            try {
                const data = await getContact( id );
                setContact(data);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }

        loadContact();
    }, [id]);

    // if ( triggered ) {
    //
    //     return null;
    // }

    const {history} = useChatContext();

    console.log(contact);

    const openAppointmentForm = () => {
        history.addMessage({
            sender: 'bot',
            text: '',
            type: 'appointment-form',
            timestamp: Date.now(),
            data: {
                contactId: id
            }
        });
    }

    const openCallbackForm = () => {
        history.addMessage({
            sender: 'bot',
            text: '',
            type: 'callback-form',
            timestamp: Date.now(),
            data: {
                contactId: id
            }
        })
    }

    if ( loading ) {

        return <LoadingMessage/>;
    }

    return (
        <>
            <p>{text}</p>
            <div className="wvcb-card wvcb-card--contact-suggestion">
                <div className="wvcb-contact">

                    <img className="wvcb-contact__image" src={contact.image}/>
                    <p className="wvcb-contact__name">{contact.firstname} {contact.lastname}</p>
                    <p className="wvcb-contact__department">Ansprechpartner für {contact.department}</p>
                    <ul className="wvcb-contact__links">
                        <li>
                            <a className="wvcb-contact__link" href={`mailto:${contact.email}`}>{contact.email}</a>
                        </li>
                        <li>
                            <a className="wvcb-contact__link" href={`tel:${contact.phone}`}>{contact.phone}</a>
                        </li>
                    </ul>

                    <div className="wvcb-toggles wvcb-toggles--contact-person wvcb-contact__toggles">
                        <button className="wvcb-toggle" onClick={() => openCallbackForm()}>
                            <header className="wvcb-toggle__header">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                     fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                     strokeLinejoin="round"
                                     className="lucide lucide-phone-icon lucide-phone">
                                    <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"/>
                                </svg>
                            </header>
                            <p className="wvcb-toggle__title">{__('Rückruf anfordern', 'wv-chat-bot')}</p>
                        </button>
                        <button className="wvcb-toggle" onClick={() => openAppointmentForm()}>
                            <header className="wvcb-toggle__header">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                     fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                     strokeLinejoin="round" className="lucide lucide-calendar-icon lucide-calendar">
                                    <path d="M16 14v2.2l1.6 1"/>
                                    <path d="M16 2v3"/>
                                    <path d="M21 7.338V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h2.338"/>
                                    <path d="M3 9h5.859"/>
                                    <path d="M8 2v3"/>
                                    <circle cx="16" cy="16" r="6"/>
                                </svg>
                            </header>
                            <p className="wvcb-toggle__title">{__('Termin ausmachen', 'wv-chat-bot')}</p>
                        </button>
                    </div>

                    <p className="wvcb-contact__phrase">
                        Hallo, ich bin {contact.firstname} {contact.lastname} und ich freue mich über eine
                        Nachricht von dir. Wir finden für dein Anliegen unverbindlich eine Lösung.
                    </p>

                </div>
            </div>
        </>
    );
}
